import env from 'pages/MyAccount/utils/env';
import requestJson from './requestJson';

export const getProductReviews = (maxPurchaseDate) => {
  const headers = { Accept: '*' };
  const queryParam = maxPurchaseDate ? `?maxPurchaseDate=${maxPurchaseDate}` : '';
  const path = `${env.questionnaireApi}/reviews/1/self/review-requests${queryParam}`;
  return requestJson(path, 'GET', headers);
};
